import { TargetingBuilderTable } from './components/TargetingBuilderTable';

export function TargetingBuilderPage() {
  return (
    <main className="page-gutter min-w-0 py-6">
      <TargetingBuilderTable />
    </main>
  );
}
